import styles from './masonry.module.scss';
import MaterialMasonry from '@mui/lab/Masonry';

/* eslint-disable-next-line */
export interface MasonryProps {
  children: any,
  // classes?: object,
  columns?: any,
  // component?: any,
  defaultColumns?: number,
  defaultHeight?: number,
  defaultSpacing?: number,
  spacing?: any,
  sx?: any
}

export function Masonry(props: MasonryProps) {
  return (
    <MaterialMasonry
      columns={props.columns}
      spacing={props.spacing}
      sx={props.sx}
      defaultColumns={props.defaultColumns}
      defaultHeight={props.defaultHeight}
      defaultSpacing={props.defaultSpacing}>
      {props.children}
    </MaterialMasonry>
  );
}

export default Masonry;